import React from "react";
import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import { OcChartData } from "../chart/chart";

interface OcChartLegendNewProps {
  data: OcChartData;
  showDivider?: boolean;
  loading?: boolean;
  isMobile: boolean;
  dividerLine?: boolean;
  minWidth?: string;
}

export const OcChartLegendNew: React.FC<OcChartLegendNewProps> = ({
  loading,
  data,
  showDivider,
  dividerLine,
  minWidth,
  isMobile,
}) => {
  const { color, label, value, valueInLegend } = data;
  const theme = useTheme();
  return (
    <Box
      id="oc-chart-legend-container"
      minWidth={minWidth ? "200px" : undefined}
    >
      <Box display="flex" id="oc-chart-legend">
        <Box
          id="oc-chart-legend-color"
          height="8px"
          width="8px"
          bgcolor={loading ? theme.palette.gray40.main : color}
          sx={{ borderRadius: "4px", margin: "10px 5px 0px 0px" }}
        />
        <Box id="oc-chart-legend-texts">
          <Typography variant="h5" color={theme.palette.gray80.main}>
            {loading ? (
              <Skeleton width="50px" />
            ) : (
              (valueInLegend ?? (value?.toString().replace(".", ",") || "0"))
            )}
          </Typography>
          <Typography variant="body1" color={theme.palette.gray60.main}>
            {loading ? <Skeleton width="150px" /> : label}
          </Typography>
        </Box>
      </Box>
      {showDivider && (
        <Box
          id="oc-chart-legend-divider"
          height="21px"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingLeft: isMobile ? undefined : "35px",
          }}
        >
          {dividerLine && (
            <Box height="1px" bgcolor={theme.palette.gray40.main} />
          )}
        </Box>
      )}
    </Box>
  );
};
